import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { RateOrderEmailRenderer } from "./email";
import type { RateOrderBlockProps } from "./types";

export function RateOrderEditorRenderer(props: RateOrderBlockProps) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <div className="[&_a]:pointer-events-none [&_a]:cursor-default">
        <RateOrderEmailRenderer isEditor {...props} />
      </div>
    </EmailComponentWrapper>
  );
}
